export default __webpack_public_path__ + "static/media/mju-logo.b4f2b043.png";